<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M27.5 52.5h9a1.5 1.5 0 000-3h-9a1.5 1.5 0 000 3z"/><path d="M57 43h-.73l-2.94-17.26a7.49 7.49 0 00-7.4-6.24H33.5V17h9a2 2 0 002-2V7a2 2 0 00-2-2h-21a2 2 0 00-2 2v8a2 2 0 002 2h9v2.5H18.07a7.49 7.49 0 00-7.4 6.24L7.73 43H7a2 2 0 00-2 2v12a2 2 0 002 2h50a2 2 0 002-2V45a2 2 0 00-2-2zM22.5 8h19v6h-19zm-8.87 18.24a4.49 4.49 0 014.44-3.74h27.86a4.49 4.49 0 014.44 3.74L53.22 43H10.78zM56 56H8V46h48z"/><path d="M17 27.5h30v6H17z"/></svg>